import { type AppDispatch } from '../../../store'
import * as OperationPermissionService from '../services/operationPermissionService'
import { operationPermissionErrorAction, operationPermissionLoadingAction, operationPermissionUpdateAction } from '../redux/operationPermissionSlice'
import * as MenuInfoService from '../services/menuInfoService'
import { menuInfoLoadingAction, menuInfoUpdateAction, menuInfoErrorAction } from './menuInfoSlice'

export const getOperationPermissions = (subId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(operationPermissionLoadingAction())
  void OperationPermissionService.getPermissions(
    subId,
    (associateAssetsResponse) => {
      dispatch(operationPermissionUpdateAction({ data: associateAssetsResponse }))
    },
    (error, httpStatus) => {
      dispatch(operationPermissionErrorAction({ error, httpStatus }))
    }
  )
}

export const fetchSidebarMenuInfo = () => async (dispatch: any): Promise<void> => {
  dispatch(menuInfoLoadingAction())
  void MenuInfoService.fetchSidebarMenuInfo(
    (menuInfoData, httpStatus) => {
      dispatch(menuInfoUpdateAction({ data: menuInfoData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(menuInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}
